async function toggleCartItemWithLoader(variantId, quantity = 1) {
    const loader = document.querySelector('img.switch__loader_prdct');
    const toggleSwitchContainer = document.querySelector('.switch__cart_protection_product__atc');
    if (toggleSwitchContainer.classList.contains("item_processing")) {
      return;
    }
    if (loader) loader.style.display = 'block';
    if (toggleSwitchContainer) toggleSwitchContainer.classList.add('item_processing');

    const toggleSwitch = toggleSwitchContainer?.querySelector('.field.toggle__switch_label');

    try {
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        const item = cart.items.find(item => item.variant_id === variantId);
        if (item) {
            await updateCartItem(item.key, 0);
            if (toggleSwitch) toggleSwitch.classList.remove('checked');
        } else {
            await addToCart(variantId, quantity);
            if (toggleSwitch) toggleSwitch.classList.add('checked');
        }
        document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch (error) {
        console.error("Error toggling cart item:", error);
    } finally {
        if (loader) loader.style.display = 'none';
        if (toggleSwitchContainer) toggleSwitchContainer.classList.remove('item_processing');
    }
}

async function addToCart(variantId, quantity) {
    const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity })
    });
    if (!response.ok) {
        throw new Error("Failed to add product to cart");
    }
    return await response.json();
}

async function updateCartItem(lineItemId, quantity) {
    const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineItemId, quantity: quantity })
    });
    if (!response.ok) {
        throw new Error("Failed to update or remove product in cart");
    }
    return await response.json();
}

function toggleSwitch__func(id) {
  toggleCartItemWithLoader(id);
}







// shipping test

function updateShippingMessage(cartValue, tier__one, tier__two) {
    const shippingBar = document.getElementById("shipping-bar");
    if (cartValue <= 0 || !shippingBar) {
      shippingBar?.classList?.add("hidden");
      return;
    }
    const shippingMessage = document.getElementById("shipping-message");
    const progressBar = document.getElementById("progress-bar");
    const currencySymbol = document.querySelector("[data-free_discounted_pr_price__currency]").getAttribute("data-free_discounted_pr_price__currency");
    let progress = 0;
    let message = "";

    // Determine the smaller and larger tiers
    const smallerTier = Math.min(tier__one, tier__two);
    const largerTier = Math.max(tier__one, tier__two);

    // Update message and progress
    if (cartValue >= largerTier) {
        message = document.querySelector("[data-shipping_threshold_text_2]")?.getAttribute("data-shipping_threshold_text_2");
        progress = 100; // Full progress for both tiers
        setTierIcons(true, true); // Both tiers reached
    } else if (cartValue >= smallerTier && largerTier > 0 || smallerTier <= 0) {
        const remainingForFreeShipping = (largerTier - cartValue).toFixed(2);
        if(smallerTier <= 0){
        progress = (cartValue / largerTier) * 100;
        }else{
        progress = 50 + ((cartValue - smallerTier) / (largerTier - smallerTier)) * 50; // Progress from 50% to 100%
        }
        message = document.querySelector("[data-shipping_threshold_text_1]")?.getAttribute("data-shipping_threshold_text_1")?.replace("#TOTAL", currencySymbol+largerTier)?.replace("#REM", currencySymbol+remainingForFreeShipping);
        setTierIcons(smallerTier >= 0, false); // First tier reached, second tier not reached
    } else if(cartValue <= smallerTier && smallerTier >= 0) {
        progress = (cartValue / smallerTier) * 50; // Progress from 0% to 50% for the first tier
        message = `Spend ${currencySymbol+smallerTier} to get a free product!`;
        setTierIcons(false, false); // No tiers reached
    }

    // Ensure progress does not exceed 100%
    progress = Math.min(progress, 100);

    shippingMessage.innerText = message;
    progressBar.style.width = `${progress}%`;
    shippingBar.classList.remove("hidden");
    if(tier__one > 0){
    document.getElementById("tier2-icon").setAttribute("data-hidden__tier__icons", 'false');
    }
    if(tier__two > 0){
    document.getElementById("tier1-icon").setAttribute("data-hidden__tier__icons", 'false');
    }
}


    // Function to set tier icons
    function setTierIcons(tier1Reached, tier2Reached) {
        document.getElementById("tier1-icon").className = tier1Reached ? "tier-icon tier-reached" : "tier-icon tier-unreached";
        document.getElementById("tier2-icon").className = tier2Reached ? "tier-icon tier-reached" : "tier-icon tier-unreached";
    }
      const currencySymbol = document.querySelector("[data-free_discounted_pr_price__currency]").getAttribute("data-free_discounted_pr_price__currency");
      const newTotal = document.querySelector("[data-cart__total]").getAttribute("data-cart__total").replace(currencySymbol, "");
      const shipping__threshold_value = +document.querySelector("[data-shipping__threshold_value]").getAttribute("data-shipping__threshold_value");
      const target_amount = +document.querySelector("[data-free_discounted_pr_price]").getAttribute("data-free_discounted_pr_price");
      updateShippingMessage(newTotal, shipping__threshold_value, target_amount);

// shipping test


function handleTotalChange(mutationsList) {
  for (const mutation of mutationsList) {
    if (
      mutation.type === "attributes" &&
      mutation.attributeName === "data-cart__total"
    ) {
      const currencySymbol = document.querySelector("[data-free_discounted_pr_price__currency]").getAttribute("data-free_discounted_pr_price__currency");
      const newTotal = +mutation.target.getAttribute("data-cart__total").replace(currencySymbol, "");
      const target_element = document.querySelector("[data-free_discounted_pr_price]");
      const target_amount = +target_element.getAttribute("data-free_discounted_pr_price");
      const target_id = +target_element.getAttribute("data-id");
      const items = document.querySelectorAll(".cart_ac_remove.js_cart_rem");
      const shipping__threshold_value = +document.querySelector("[data-shipping__threshold_value]").getAttribute("data-shipping__threshold_value");
      let all_item_ids=[];
      
      updateShippingMessage(newTotal, shipping__threshold_value, target_amount);
      
      items.forEach((item) => {
        const item_id = +item.getAttribute("data-id").split(":")[0];
        all_item_ids.push(item_id);
      });
      if(!all_item_ids.includes(target_id) && newTotal >= target_amount){
          target_element.click();
      }
    }
  }
}


const custom_observer = new MutationObserver(handleTotalChange);
const footer_itm = document.querySelector(".mini_cart_footer.js_cart_footer") ?? document.querySelector(".cart__footer");
custom_observer.observe(footer_itm, { attributes: true });

addEventListener("DOMContentLoaded", (event) => {
  const floating_btn = document.querySelector(".floating_cart_button__main.push_side");
  if(floating_btn) floating_btn.style.display = "block";
});